/**
 * pcmProcessorCode.js
 * Inlined AudioWorkletProcessor script string for bulletproof Blob URL initialization.
 */

export const PCM_PROCESSOR_CODE = `
class PCMRecorderProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this.targetSampleRate = 16000;
    this.inputSampleRate = sampleRate;
    this.bufferSize = 2048;
    this.outputBuffer = new Int16Array(this.bufferSize);
    this.bufferIndex = 0;
    this.resampleRatio = this.inputSampleRate / this.targetSampleRate;
    this.resampleOffset = 0;
    this.isRecording = true;

    this.port.onmessage = (event) => {
      const data = event.data;
      if (data && data.command === "stop") {
        this.isRecording = false;
        if (this.bufferIndex > 0) {
          const flushed = this.outputBuffer.slice(0, this.bufferIndex);
          this.port.postMessage({
            event: "pcm-chunk",
            buffer: flushed.buffer
          }, [flushed.buffer]);
          this.bufferIndex = 0;
        }
      } else if (data && data.command === "start") {
        this.isRecording = true;
        this.bufferIndex = 0;
        this.resampleOffset = 0;
      }
    };
  }

  process(inputs, outputs, parameters) {
    if (!this.isRecording) return true;

    const input = inputs[0];
    if (!input || !input[0] || input[0].length === 0) return true;

    const channelData = input[0];
    const inputLength = channelData.length;

    if (this.inputSampleRate === this.targetSampleRate) {
      for (let i = 0; i < inputLength; i++) {
        const s = Math.max(-1, Math.min(1, channelData[i]));
        this.outputBuffer[this.bufferIndex++] = s < 0 ? s * 0x8000 : s * 0x7fff;
        if (this.bufferIndex >= this.bufferSize) {
          this._flushChunk();
        }
      }
    } else {
      while (this.resampleOffset < inputLength) {
        const index = Math.floor(this.resampleOffset);
        const frac = this.resampleOffset - index;
        const s0 = channelData[index];
        const s1 = (index + 1 < inputLength) ? channelData[index + 1] : s0;
        const interpolated = s0 + frac * (s1 - s0);

        const s = Math.max(-1, Math.min(1, interpolated));
        this.outputBuffer[this.bufferIndex++] = s < 0 ? s * 0x8000 : s * 0x7fff;

        if (this.bufferIndex >= this.bufferSize) {
          this._flushChunk();
        }

        this.resampleOffset += this.resampleRatio;
      }
      this.resampleOffset -= inputLength;
    }

    return true;
  }

  _flushChunk() {
    const chunk = new Int16Array(this.bufferSize);
    chunk.set(this.outputBuffer);
    this.port.postMessage({
      event: "pcm-chunk",
      buffer: chunk.buffer
    }, [chunk.buffer]);
    this.bufferIndex = 0;
  }
}

registerProcessor("pcm-recorder-processor", PCMRecorderProcessor);
`;
